import React from "react";
import Icecekler from './kategoriler/Icecekler.jsx';
import Yemekler from './kategoriler/Yemekler.jsx';
import SicakKahveler from './kategori/icecekler/sicak-kahveler/SicakKahveler.jsx';
import Cappuccino from './kategori/icecekler/sicak-kahveler/Cappuccino.jsx';
import CafeLatte from './kategori/icecekler/sicak-kahveler/CafeLatte.jsx';
// Yeni sıcak kahve bileşenleri
import Espresso from './kategori/icecekler/sicak-kahveler/Espresso.jsx';
import DoubleEspresso from './kategori/icecekler/sicak-kahveler/DoubleEspresso.jsx';
import Cortada from './kategori/icecekler/sicak-kahveler/Cortada.jsx';
import EspressoMacchiato from './kategori/icecekler/sicak-kahveler/EspressoMacchiato.jsx';
import DoubleEspressoMacchiato from './kategori/icecekler/sicak-kahveler/DoubleEspressoMacchiato.jsx';
import EspressoConPanna from './kategori/icecekler/sicak-kahveler/EspressoConPanna.jsx';
import DoubleEspressoConPanna from './kategori/icecekler/sicak-kahveler/DoubleEspressoConPanna.jsx';
import CafeLatteMacchiato from './kategori/icecekler/sicak-kahveler/CafeLatteMacchiato.jsx';
import FlatWhite from './kategori/icecekler/sicak-kahveler/FlatWhite.jsx';
import Ristretto from './kategori/icecekler/sicak-kahveler/Ristretto.jsx';
import LungoEspresso from './kategori/icecekler/sicak-kahveler/LungoEspresso.jsx';
import Americano from './kategori/icecekler/sicak-kahveler/Americano.jsx';
import RedEye from './kategori/icecekler/sicak-kahveler/RedEye.jsx';
import CikolataliMocha from './kategori/icecekler/soguk-kahveler/CikolataliMocha.jsx';
import BeyazCikolataliMocha from './kategori/icecekler/soguk-kahveler/BeyazCikolataliMocha.jsx';
import KaramelliMocha from './kategori/icecekler/soguk-kahveler/KaramelliMocha.jsx';
// Yeni sıcak mocha bileşenleri
import SicakCikolataliMocha from './kategori/icecekler/sicak-kahveler/SicakCikolataliMocha.jsx';
import SicakBeyazCikolataliMocha from './kategori/icecekler/sicak-kahveler/SicakBeyazCikolataliMocha.jsx';
import SicakKaramelliMocha from './kategori/icecekler/sicak-kahveler/SicakKaramelliMocha.jsx';
// Yeni Special Kahve bileşenleri
import Zebra from './kategori/icecekler/sicak-kahveler/Zebra.jsx';
import CikitaCoffee from './kategori/icecekler/sicak-kahveler/CikitaCoffee.jsx';
import CheryCheryLady from './kategori/icecekler/sicak-kahveler/CheryCheryLady.jsx';
import ValentinesCoffee from './kategori/icecekler/sicak-kahveler/ValentinesCoffee.jsx';
import IrishCreamCoffee from './kategori/icecekler/sicak-kahveler/IrishCreamCoffee.jsx';
import BaileysCoffeeAlkolsuz from './kategori/icecekler/sicak-kahveler/BaileysCoffeeAlkolsuz.jsx';
import SogukKahveler from './kategori/icecekler/soguk-kahveler/SogukKahveler.jsx';
import MaviCilekliIceLatte from './kategori/icecekler/soguk-kahveler/maviCilekliIceLatte.jsx';
import ItalyanKaramelIceLatte from './kategori/icecekler/soguk-kahveler/italyanKaramelIceLatte.jsx';
import TuzluKaramelIceLatte from './kategori/icecekler/soguk-kahveler/tuzluKaramelIceLatte.jsx';
import BaileysIceLatte from './kategori/icecekler/soguk-kahveler/baileysIceLatte.jsx';
import VirginiaCoffee from './kategori/icecekler/soguk-kahveler/virginiaCoffee.jsx';
import WakaWaka from './kategori/icecekler/soguk-kahveler/wakaWaka.jsx';
import CoolNut from './kategori/icecekler/soguk-kahveler/coolNut.jsx';
import OreoCoffee from './kategori/icecekler/soguk-kahveler/oreoCoffee.jsx';
import Kitirli from './kategori/icecekler/soguk-kahveler/kitirli.jsx';
import Sipsevdi from './kategori/icecekler/soguk-kahveler/sipsevdi.jsx';
import SweetBaby from './kategori/icecekler/soguk-kahveler/sweetBaby.jsx';
import MelonSapka from './kategori/icecekler/soguk-kahveler/melonSapka.jsx';
import CheeseCake from './kategori/icecekler/soguk-kahveler/cheeseCake.jsx';
import JavaChip from './kategori/icecekler/soguk-kahveler/javaChip.jsx';
import IceAmericano from './kategori/icecekler/soguk-kahveler/ice-americano.jsx';
import IceLatte from './kategori/icecekler/soguk-kahveler/ice-latte.jsx';
import IceCappuccino from './kategori/icecekler/soguk-kahveler/ice-cappuccino.jsx';
import Frappe from './kategori/icecekler/soguk-kahveler/frappe.jsx';
import ColdBrew from './kategori/icecekler/soguk-kahveler/cold-brew.jsx';
import Affogato from './kategori/icecekler/soguk-kahveler/affogato.jsx';

import SicakIcecekler from './kategori/icecekler/sicak-icecekler/SicakIcecekler.jsx';
import BuyukCay from './kategori/icecekler/sicak-icecekler/BuyukCay.jsx';
import FiltreKahve from './kategori/icecekler/sicak-icecekler/FiltreKahve.jsx';
import SutluFiltreKahve from './kategori/icecekler/sicak-icecekler/SutluFiltreKahve.jsx';
import SicakCikolata from './kategori/icecekler/sicak-icecekler/SicakCikolata.jsx';
import KahveliSicakCikolata from './kategori/icecekler/sicak-icecekler/KahveliSicakCikolata.jsx';
import SicakBeyazCikolata from './kategori/icecekler/sicak-icecekler/SicakBeyazCikolata.jsx';
import Salep from './kategori/icecekler/sicak-icecekler/Salep.jsx';
import SalepliKahve from './kategori/icecekler/sicak-icecekler/SalepliKahve.jsx';
import ChaiTeaLatte from './kategori/icecekler/sicak-icecekler/ChaiTeaLatte.jsx';
import MatchaTeaLatte from './kategori/icecekler/sicak-icecekler/MatchaTeaLatte.jsx';
import Detox from './kategori/icecekler/sicak-icecekler/Detox.jsx';
import SicakBerryHibiscus from './kategori/icecekler/sicak-icecekler/SicakBerryHibiscus.jsx';
import Theraphy from './kategori/icecekler/sicak-icecekler/Theraphy.jsx';
import Masala from './kategori/icecekler/sicak-icecekler/Masala.jsx';
import Form from './kategori/icecekler/sicak-icecekler/Form.jsx';
import Cool from './kategori/icecekler/sicak-icecekler/Cool.jsx';
import RooibosVanillia from './kategori/icecekler/sicak-icecekler/RooibosVanillia.jsx';
import WhiteBlue from './kategori/icecekler/sicak-icecekler/WhiteBlue.jsx';
import Papatya from './kategori/icecekler/sicak-icecekler/Papatya.jsx';
import Melisa from './kategori/icecekler/sicak-icecekler/Melisa.jsx';
import Ihlamur from './kategori/icecekler/sicak-icecekler/Ihlamur.jsx';
import ElmaTarcinKarisik from './kategori/icecekler/sicak-icecekler/ElmaTarcinKarisik.jsx';
import SogukIcecekler from './kategori/icecekler/soguk-icecekler/SogukIcecekler.jsx';
import Limonata from './kategori/icecekler/soguk-icecekler/Limonata.jsx';
import PortakalSuyu from './kategori/icecekler/soguk-icecekler/PortakalSuyu.jsx';
import Milkshake from './kategori/icecekler/soguk-icecekler/Milkshake.jsx';
import Frozen from './kategori/icecekler/soguk-icecekler/Frozen.jsx';
import Ayran from './kategori/icecekler/soguk-icecekler/Ayran.jsx';
import FeslegenliAyran from './kategori/icecekler/soguk-icecekler/FeslegenliAyran.jsx';

import Kokteyller from './kategori/icecekler/kokteyller/Kokteyller.jsx';
import Lalika from './kategori/icecekler/kokteyller/lalika.jsx';
import CoolLimeCilekli from './kategori/icecekler/kokteyller/coolLimeCilekli.jsx';
import CoolLimeMentollu from './kategori/icecekler/kokteyller/coolLimeMentollu.jsx';
import Sangria from './kategori/icecekler/kokteyller/sangria.jsx';
import BlueLagoon from './kategori/icecekler/kokteyller/blueLagoon.jsx';
import BlueHawai from './kategori/icecekler/kokteyller/blueHawai.jsx';
import BerryHibiscus from './kategori/icecekler/kokteyller/berryHibiscus.jsx';
import Mesrubatlar from './kategori/icecekler/mesrubatlar/Mesrubatlar.jsx';
import DostlukPekistirenler from './kategori/yemekler/DostlukPekistirenler.jsx';
import ComboSicakTabagi from './kategori/yemekler/combo-sicak-tabagi.jsx';
import ComboBurger from './kategori/yemekler/combo-burger.jsx';
import CajunBasket from './kategori/yemekler/cajun-basket.jsx';
import BorekBasket from './kategori/yemekler/borek-basket.jsx';
import PatatesTabagi from './kategori/yemekler/patates-tabagi.jsx';
import Patso from './kategori/yemekler/patso.jsx';
import SosisBasket from './kategori/yemekler/sosis-basket.jsx';
import Gozlemeler from './kategoriler/Gozlemeler.jsx';
import HamburgEr from './kategori/yemekler/hamburg-er.jsx';
import CiftKofteTekLezzet from './kategori/yemekler/cift-kofte-tek-lezzet.jsx';
import Hamburgerler from './kategoriler/Hamburgerler.jsx';
import Makarnalar from './kategoriler/Makarnalar.jsx';
import Alfredo from './kategori/yemekler/alfredo.jsx';
import PastaItaliano from './kategori/yemekler/pasta-italiano.jsx';
import Pesto from './kategori/yemekler/pesto.jsx';
import ChickenMushroom from './kategori/yemekler/chicken-mushroom.jsx';
import Arabiatta from './kategori/yemekler/arabiatta.jsx';
import Tostlar from './kategoriler/Tostlar.jsx';
import KasarliTost from './kategori/yemekler/kasarli-tost.jsx';
import KasarliSucukluTost from './kategori/yemekler/kasarli-sucuklu-tost.jsx';
import Wraplar from './kategoriler/Wraplar.jsx';
import KofteWrap from './kategori/yemekler/kofte-wrap.jsx';
import TavukluWrap from './kategori/yemekler/tavuklu-wrap.jsx';
import TurkKahveleri from './kategori/icecekler/turk-kahveleri/TurkKahveleri.jsx';
import TurkKahvesi from './kategori/icecekler/turk-kahveleri/turkKahvesi.jsx';
import DoubleTurkKahvesi from './kategori/icecekler/turk-kahveleri/doubleTurkKahvesi.jsx';
import DibekTurkKahvesi from './kategori/icecekler/turk-kahveleri/dibekTurkKahvesi.jsx';
import DoubleDibekTurkKahvesi from './kategori/icecekler/turk-kahveleri/doubleDibekTurkKahvesi.jsx';
import CilekliTurkKahvesi from './kategori/icecekler/turk-kahveleri/cilekliTurkKahvesi.jsx';
import DoubleCilekliTurkKahvesi from './kategori/icecekler/turk-kahveleri/doubleCilekliTurkKahvesi.jsx';
import DamlaSakizliTurkKahvesi from './kategori/icecekler/turk-kahveleri/damlaSakizliTurkKahvesi.jsx';
import DoubleDamlaSakizliTurkKahvesi from './kategori/icecekler/turk-kahveleri/doubleDamlaSakizliTurkKahvesi.jsx';
import KumdaTurkKahvesi from './kategori/icecekler/turk-kahveleri/kumdaTurkKahvesi.jsx';
import OnlineMagazaSection from './OnlineMagazaSection.jsx';

const MainSection = ({ activeSection }) => {
	return (
		<section style={{ maxWidth: '1200px', margin: '0 auto' }}>
			{activeSection === 'menu' && (
				<>
					<h1 className="main-section-title" style={{ display: 'flex', flexDirection: 'row-reverse', margin: '20px', fontWeight: '700' }}>Menü</h1>
					<Icecekler />
					<Yemekler />
				</>
			)}
			{activeSection === 'online-magaza' && <OnlineMagazaSection />}
			{activeSection === 'sicak-kahveler' && <SicakKahveler />}
			{activeSection === 'sicak-icecekler' && <SicakIcecekler />}
			{activeSection === 'buyuk-cay' && <BuyukCay />}
			{activeSection === 'filtre-kahve' && <FiltreKahve />}
			{activeSection === 'sutlu-filtre-kahve' && <SutluFiltreKahve />}
			{activeSection === 'sicak-cikolata' && <SicakCikolata />}
			{activeSection === 'kahveli-sicak-cikolata' && <KahveliSicakCikolata />}
			{activeSection === 'sicak-beyaz-cikolata' && <SicakBeyazCikolata />}
			{activeSection === 'salep' && <Salep />}
			{activeSection === 'salepli-kahve' && <SalepliKahve />}
			{activeSection === 'chai-tea-latte' && <ChaiTeaLatte />}
			{activeSection === 'matcha-tea-latte' && <MatchaTeaLatte />}
			{activeSection === 'detox' && <Detox />}
			{activeSection === 'sicak-berry-hibiscus' && <SicakBerryHibiscus />}
			{activeSection === 'theraphy' && <Theraphy />}
			{activeSection === 'masala' && <Masala />}
			{activeSection === 'form' && <Form />}
			{activeSection === 'cool' && <Cool />}
			{activeSection === 'rooibos-vanillia' && <RooibosVanillia />}
			{activeSection === 'white-blue' && <WhiteBlue />}
			{activeSection === 'papatya' && <Papatya />}
			{activeSection === 'melisa' && <Melisa />}
			{activeSection === 'ihlamur' && <Ihlamur />}
			{activeSection === 'elma-tarcin-karisik' && <ElmaTarcinKarisik />}
			{activeSection === 'cappuccino' && <Cappuccino />}
			{activeSection === 'cafe-latte' && <CafeLatte />}
			{activeSection === 'espresso' && <Espresso />}
			{activeSection === 'double-espresso' && <DoubleEspresso />}
			{activeSection === 'cortada' && <Cortada />}
			{activeSection === 'espresso-macchiato' && <EspressoMacchiato />}
			{activeSection === 'double-espresso-macchiato' && <DoubleEspressoMacchiato />}
			{activeSection === 'espresso-con-panna' && <EspressoConPanna />}
			{activeSection === 'double-espresso-con-panna' && <DoubleEspressoConPanna />}
			{activeSection === 'cafe-latte-macchiato' && <CafeLatteMacchiato />}
			{activeSection === 'flat-white' && <FlatWhite />}
			{activeSection === 'ristretto' && <Ristretto />}
			{activeSection === 'lungo-espresso' && <LungoEspresso />}
			{activeSection === 'americano' && <Americano />}
			{activeSection === 'red-eye' && <RedEye />}
			{activeSection === 'cikolatali-mocha' && <SicakCikolataliMocha />}
			{activeSection === 'beyaz-cikolatali-mocha' && <SicakBeyazCikolataliMocha />}
			{activeSection === 'karamelli-mocha' && <SicakKaramelliMocha />}
			{activeSection === 'zebra' && <Zebra />}
			{activeSection === 'cikita-coffee' && <CikitaCoffee />}
			{activeSection === 'chery-chery-lady' && <CheryCheryLady />}
			{activeSection === 'valentines-coffee' && <ValentinesCoffee />}
			{activeSection === 'irish-cream-coffee' && <IrishCreamCoffee />}
			{activeSection === 'baileys-coffee-alkolsuz' && <BaileysCoffeeAlkolsuz />}
			{activeSection === 'soguk-kahveler' && <SogukKahveler />}
			{activeSection === 'mavi-cilekli-ice-latte' && <MaviCilekliIceLatte />}
			{activeSection === 'italyan-karamel-ice-latte' && <ItalyanKaramelIceLatte />}
			{activeSection === 'tuzlu-karamel-ice-latte' && <TuzluKaramelIceLatte />}
			{activeSection === 'baileys-ice-latte' && <BaileysIceLatte />}
			{activeSection === 'virginia-coffee' && <VirginiaCoffee />}
			{activeSection === 'waka-waka' && <WakaWaka />}
			{activeSection === 'cool-nut' && <CoolNut />}
			{activeSection === 'oreo-coffee' && <OreoCoffee />}
			{activeSection === 'kitirli' && <Kitirli />}
			{activeSection === 'sipsevdi' && <Sipsevdi />}
			{activeSection === 'sweet-baby' && <SweetBaby />}
			{activeSection === 'melon-sapka' && <MelonSapka />}
			{activeSection === 'cheese-cake' && <CheeseCake />}
			{activeSection === 'java-chip' && <JavaChip />}
			{activeSection === 'ice-americano' && <IceAmericano />}
			{activeSection === 'ice-latte' && <IceLatte />}
			{activeSection === 'ice-cappuccino' && <IceCappuccino />}
			{activeSection === 'frappe' && <Frappe />}
			{activeSection === 'cold-brew' && <ColdBrew />}
			{activeSection === 'affogato' && <Affogato />}
			{activeSection === 'soguk-icecekler' && <SogukIcecekler />}
			{activeSection === 'limonata' && <Limonata />}
			{activeSection === 'portakal-suyu' && <PortakalSuyu />}
			{activeSection === 'milkshake' && <Milkshake />}
			{activeSection === 'frozen' && <Frozen />}
			{activeSection === 'ayran' && <Ayran />}
			{activeSection === 'feslegenli-ayran' && <FeslegenliAyran />}
			{activeSection === 'ice-cikolatali-mocha' && <CikolataliMocha />}
			{activeSection === 'ice-beyaz-cikolatali-mocha' && <BeyazCikolataliMocha />}
			{activeSection === 'ice-karamelli-mocha' && <KaramelliMocha />}
			{activeSection === 'kokteyller' && <Kokteyller />}
			{activeSection === 'lalika' && <Lalika />}
			{activeSection === 'cool-lime-cilekli' && <CoolLimeCilekli />}
			{activeSection === 'cool-lime-mentollu' && <CoolLimeMentollu />}
			{activeSection === 'sangria' && <Sangria />}
			{activeSection === 'blue-lagoon' && <BlueLagoon />}
			{activeSection === 'blue-hawai' && <BlueHawai />}
			{activeSection === 'berry-hibiscus' && <BerryHibiscus />}
			{activeSection === 'turk-kahveleri' && <TurkKahveleri />}
			{activeSection === 'mesrubatlar' && <Mesrubatlar />}
			{activeSection === 'dostluk-pekistirenler' && <DostlukPekistirenler />}
			{activeSection === 'combo-sicak-tabagi' && <ComboSicakTabagi />}
			{activeSection === 'combo-burger' && <ComboBurger />}
			{activeSection === 'cajun-basket' && <CajunBasket />}
			{activeSection === 'borek-basket' && <BorekBasket />}
			{activeSection === 'patates-tabagi' && <PatatesTabagi />}
			{activeSection === 'patso' && <Patso />}
			{activeSection === 'sosis-basket' && <SosisBasket />}
			{activeSection === 'gozlemeler' && <Gozlemeler />}
			{activeSection === 'hamburgerler' && <Hamburgerler />}
			{activeSection === 'makarnalar' && <Makarnalar />}
			{activeSection === 'alfredo' && <Alfredo />}
			{activeSection === 'pasta-italiano' && <PastaItaliano />}
			{activeSection === 'pesto' && <Pesto />}
			{activeSection === 'chicken-mushroom' && <ChickenMushroom />}
			{activeSection === 'arabiatta' && <Arabiatta />}
			{activeSection === 'tostlar' && <Tostlar />}
			{activeSection === 'kasarli-tost' && <KasarliTost />}
			{activeSection === 'kasarli-sucuklu-tost' && <KasarliSucukluTost />}
			{activeSection === 'wraplar' && <Wraplar />}
			{activeSection === 'kofte-wrap' && <KofteWrap />}
			{activeSection === 'tavuklu-wrap' && <TavukluWrap />}
			{activeSection === 'hamburger' && <HamburgEr />}
			{activeSection === 'cift-kofte-tek-lezzet' && <CiftKofteTekLezzet />}
			{activeSection === 'turk-kahvesi' && <TurkKahvesi />}
			{activeSection === 'double-turk-kahvesi' && <DoubleTurkKahvesi />}
			{activeSection === 'dibek-turk-kahvesi' && <DibekTurkKahvesi />}
			{activeSection === 'double-dibek-turk-kahvesi' && <DoubleDibekTurkKahvesi />}
			{activeSection === 'cilekli-turk-kahvesi' && <CilekliTurkKahvesi />}
			{activeSection === 'double-cilekli-turk-kahvesi' && <DoubleCilekliTurkKahvesi />}
			{activeSection === 'damla-sakizli-turk-kahvesi' && <DamlaSakizliTurkKahvesi />}
			{activeSection === 'double-damla-sakizli-turk-kahvesi' && <DoubleDamlaSakizliTurkKahvesi />}
			{activeSection === 'kumda-turk-kahvesi' && <KumdaTurkKahvesi />}
		</section>
	);
};

export default MainSection;
